import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 97 56.8",
  x: "0px",
  y: "0px",
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M0.5,28.4C0.5,12.8,23,0.5,51.8,0.5c1.7,0,3,1.3,3,3v49.8c0,1.7-1.3,3-3,3 C23,56.3,0.5,44.1,0.5,28.4z M41.7,7.1v42.6c2.3,0.3,4.7,0.5,7.1,0.5V6.6C46.4,6.6,44,6.8,41.7,7.1z M6.5,28.4 c0,9.5,13.3,17.8,31.2,20.8V7.7C19.8,10.6,6.5,18.9,6.5,28.4z M65.1,49.7c-1.7,0-3-1.3-3-3s1.3-3,3-3h28.4c1.7,0,3,1.3,3,3 s-1.3,3-3,3H65.1z M65.1,37.5c-1.7,0-3-1.3-3-3s1.3-3,3-3h28.4c1.7,0,3,1.3,3,3s-1.3,3-3,3H65.1z M65.1,25.3c-1.7,0-3-1.3-3-3 s1.3-3,3-3h28.4c1.7,0,3,1.3,3,3s-1.3,3-3,3H65.1z M65.1,13.2c-1.7,0-3-1.3-3-3s1.3-3,3-3h28.4c1.7,0,3,1.3,3,3s-1.3,3-3,3H65.1z",
      fill: $props.color
    }, null, 8, _hoisted_2)
  ]))
}